import { CardTabListType } from 'antd/lib/card';
import { TResourceAction } from 'interfaces/resources';
import { useCanMultiple } from 'components/layout/sider';

export interface Tab {
  key: string;
  label: string;
  permissions: {
    resource: `professor_area/${string}`;
    action: TResourceAction;
  }[];
}

export const tabs: Tab[] = [
  {
    key: 'general',
    label: 'Visão geral',
    permissions: [{ resource: 'professor_area/classrooms', action: 'list' }]
  },
  {
    key: 'content',
    label: 'Conteúdo',
    permissions: [{ resource: 'professor_area/classrooms', action: 'list' }]
  },
  {
    key: 'interactiveClass',
    label: 'Aulas interativas',
    permissions: [
      { resource: 'professor_area/interactive_classes', action: 'list' }
    ]
  },
  {
    key: 'assignments',
    label: 'Atividades',
    permissions: [
      { resource: 'professor_area/classroom_assignments', action: 'list' }
    ]
  },
  {
    key: 'evaluations',
    label: 'Avaliações',
    permissions: [
      { resource: 'professor_area/classroom_assessments', action: 'list' }
    ]
  },
  {
    key: 'forums',
    label: 'Fórum',
    permissions: [{ resource: 'professor_area/forums', action: 'list' }]
  },
  {
    key: 'noticeBoard',
    label: 'Mural de avisos',
    permissions: [{ resource: 'professor_area/notice_boards', action: 'list' }]
  },
  {
    key: 'supplementaryMaterials',
    label: 'Materiais complementares',
    permissions: [{ resource: 'professor_area/classrooms', action: 'list' }]
  },
  {
    key: 'students',
    label: 'Alunos',
    permissions: [
      { resource: 'professor_area/classroom_enrollments', action: 'list' }
    ]
  }
];

export const useShownTabs = () => {
  const tabPermissions = tabs.flatMap(tab => tab.permissions);
  const canShowPermissions = useCanMultiple(tabPermissions);

  let permissionIndex = 0;

  const shownTabs = tabs.reduce((acc, { key, label, permissions }) => {
    const tabCan = permissions.some((_permission, localIndex) => {
      const query = canShowPermissions[permissionIndex + localIndex];
      return query?.data?.can;
    });

    permissionIndex += permissions.length;

    if (tabCan) {
      acc.push({ key, label });
    }

    return acc;
  }, [] as CardTabListType[]);

  return { shownTabs };
};
